/**
 * Pure helpers for the map-details deep-link flow.
 * Kept in lib/ so they can be unit-tested without importing any
 * React Native / expo-router modules.
 */

/**
 * Returns the region id to pre-select when the map-details screen mounts,
 * derived from the optional `region` search param.  Returns null when no
 * param is present so the screen opens with no region highlighted.
 */
export function initialRegionId(param: string | undefined): string | null {
  return param ?? null
}
